import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dict" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = { class: "footer" }

import { searchFormConfig } from './config/search.config';
import { contentTableConfig } from './config/content.config';
import { modalConfig } from './config/modal.config';
import PageModal from "@/components/PageModal.vue";
import { usePageModal } from "@/hooks/usePageModal";
import { reactive, ref } from "vue";
import { usePageSearch } from "@/hooks/userPageSearch";
import { createPageData, editPageData, deletePageData, getPageListData } from "@/service/main/system";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dict',
  setup(__props) {

const modalTitle = ref('');
const newCb = ()=> {
  modalTitle.value = "新增字典";
}
const editCb = ()=> {
  modalTitle.value = "编辑字典";
}
const page = ref({pageNo: 1, pageSize: 10});
const listCount = ref(0);
const handleSizeChange = (pageSize: number)=> {
  page.value.pageSize = pageSize;
  handleConfigClick({id: dictId.value});
}
const handleCurrentChange = (pageNo: number) => {
  page.value.pageNo = pageNo;
  handleConfigClick({id: dictId.value});
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch();
const dictId = ref(0);
const handleConfigClick = (item: any) => {
  debugger
  dictDrawer.value = true;
  dictId.value = item.id;
  getPageListData('/main/dictItem/queryByCondition', {
    pageNo: page.value.pageNo,
    pageSize: page.value.pageSize,
    dictId: dictId.value
  }).then(res=> {
    dictItems.value = res.list;
    listCount.value = Number(res.total);
  });
}
const dictDrawer = ref(false);
const dictItems = ref([]);
const newDialogVisible = ref(false);
const title = ref('');
const handleNewItem = ()=> {
  newDialogVisible.value = true;
  title.value = "新增";
  dictItem.id='';
  dictItem.itemText= '';
  dictItem.itemValue= '';
  dictItem.description= '';
  dictItem.sortOrder= '';
  dictItem.status= true;
}

const itemStatus = ref(false);
const handleConfirm = (item: any)=> {
  debugger
  newDialogVisible.value = false;
  let url = '';
  if (title.value == '新增') {
    url = '/main/dictItem/add';
    createPageData(url, {
      ...item,
      dictId: dictId.value
    }).then(res=>{
      handleConfigClick({id: dictId.value});
    });
  } else if (title.value == '编辑') {
    url = '/main/dictItem/'+item.id;
    editPageData(url, {
      ...item,
      dictId: dictId.value
    }).then(res=>{
      handleConfigClick({id: dictId.value});
    });
  }
}
const dictItem = reactive({
  id: '',
  itemText: '',
  itemValue: '',
  description: '',
  sortOrder: '',
  status: true
});
const handleEditClick = (id: number) => {
  debugger
  title.value = "编辑";
  newDialogVisible.value = true;
  getPageListData('/main/dictItem/queryById/'+id, null)
  .then(res=> {
    dictItem.id = res.id;
    dictItem.itemValue= res.itemValue;
    dictItem.itemText = res.itemText;
    dictItem.description = res.description;
    dictItem.sortOrder = res.sortOrder;
    dictItem.status = res.status;
  })
}
const handleDeleteClick = (id: number) => {
  deletePageData('/main/dictItem/'+id).then(res=> {
    handleConfigClick({id: dictId.value});
  });
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: _unref(handleResetClick),
        onSearchBtnClick: _unref(handleSearchClick)
      }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
      _createVNode(_component_PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: "dict",
        onNewBtnClick: _unref(handleNewData),
        onEditBtnClick: _unref(handleEditData),
        onConfigClick: handleConfigClick
      }, null, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
      _createVNode(PageModal, {
        ref_key: "pageModalRef",
        ref: pageModalRef,
        "modal-config": _unref(modalConfig),
        defaultInfo: _unref(defaultInfo),
        title: modalTitle.value,
        validOtherInfo: () => true,
        pageName: "dict"
      }, null, 8, ["modal-config", "defaultInfo", "title"]),
      _createVNode(_component_el_dialog, {
        modelValue: newDialogVisible.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newDialogVisible).value = $event)),
        title: title.value
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (newDialogVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (handleConfirm(dictItem)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确认 ")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, { model: dictItem }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: dictItem.itemText,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dictItem.itemText) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "数据值" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: dictItem.itemValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dictItem.itemValue) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "描述" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: dictItem.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dictItem.description) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "排序" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: dictItem.sortOrder,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dictItem.sortOrder) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "是否启用" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: dictItem.status,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dictItem.status) = $event)),
                    "active-text": "启用",
                    "inactive-text": "不启用"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "hidden",
                    modelValue: dictItem.dictId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dictItem.dictId) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createVNode(_component_el_drawer, {
      title: "字典列表",
      modelValue: dictDrawer.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dictDrawer).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleNewItem
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增")
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, { data: dictItems.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "名称",
              property: "itemText"
            }),
            _createVNode(_component_el_table_column, {
              label: "数据值",
              property: "itemValue"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              property: "id"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  icon: "el-icon-edit",
                  onClick: ($event: any) => (handleEditClick(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  icon: "el-icon-delete",
                  onClick: ($event: any) => (handleDeleteClick(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            "current-page": page.value.pageNo,
            "page-sizes": [10, 20, 30, 40],
            "page-size": page.value.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: listCount.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})